
import { WhatsAppAppointmentButton } from '../WhatsAppAppointmentButton'

export function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-neuro-blue/80 to-neuro-blue py-20 overflow-hidden">
      {/* Patrón sutil de puntos blancos */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle, white 1px, transparent 1px)`,
          backgroundSize: '20px 20px'
        }}></div>
      </div>
      
      {/* Formas abstractas redondeadas suaves - Ajustadas para coincidir con la imagen */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-neuro-red/20 rounded-full"></div>
      <div className="absolute bottom-20 right-20 w-24 h-24 bg-neuro-yellow/20 rounded-full"></div>
      <div className="absolute top-1/3 right-1/4 w-20 h-20 bg-neuro-green/20 rounded-full"></div>
      <div className="absolute bottom-1/3 left-1/4 w-28 h-28 bg-neuro-red/15 rounded-full"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fadeIn text-white">
              Centro de Especialidades para el abordaje del Neurodesarrollo Infantil en Heredia
            </h1>
            <p className="text-xl md:text-xl mb-8 text-white/90 animate-fadeIn animate-delay-200">
              Una solución integral para población infanto-juvenil con alteraciones del desarrollo. Atendemos niños, niñas, y jóvenes desde el nacimiento hasta los 18 años con enfoques basados en evidencia científica y en equipo con la Familia, la Escuela y Profesionales.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-fadeIn animate-delay-300 mb-6">
              <WhatsAppAppointmentButton
                className="bg-neuro-green text-neuro-dark-blue px-8 py-4 rounded-full font-semibold text-lg hover:bg-green-500 transition-all transform hover:scale-105 text-center flex items-center justify-center gap-2"
                message="Hola, me interesa agendar una cita para mi hijo/a en Neuro Peques. ¿Podrían brindarme información sobre disponibilidad y el proceso de evaluación inicial?"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"></path>
                </svg>
                Agenda una Cita
              </WhatsAppAppointmentButton>
              <a
                href="#servicios"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-neuro-blue transition-all text-center"
              >
                Nuestros Servicios
              </a>
            </div>
            
          </div>
          
          <div className="relative">
            <img
              src="/images/hero-children-playing.jpg"
              alt="Niños felices en terapia"
              className="rounded-2xl shadow-2xl w-full max-w-md h-80 md:h-96 object-cover border-4 border-white"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
            {/* Formas abstractas superpuestas en la imagen */}
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-neuro-yellow/20 rounded-full"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-neuro-green/20 rounded-full"></div>
          </div>
        </div>
      </div>
      
      {/* Borde ondulado en la parte inferior - CURVA INVERTIDA */}
      <div className="absolute bottom-0 left-0 w-full">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-16">
          <path d="M0,120V73.71c47.79-22.2,103.59-32.17,158-28,70.36,5.37,136.33,33.31,206.8,37.5C438.64,87.57,512.34,66.33,583,47.95c69.27-18,138.3-24.88,209.4-13.08,36.15,6,69.85,17.84,104.45,29.34C989.49,95,1113,134.29,1200,67.53V120Z" fill="white"></path>
        </svg>
      </div>
    </section>
  )
}
